<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Partager une ligne du temps</p>
		</header>
		<section class="modal-card-body">
            <template v-if="!inviteForm">
            <p style="margin-bottom: 10px; font-weight: bold;">
                <template v-if="users.length > 0 || timeline.published">
                    Personnes qui ont accès à cette ligne du temps:
                </template>
                <template v-else>
                    Cette ligne du temps n'a pas encore été partagée avec d'autres utilisateurs.
                </template>
            </p>

            <table class="table is-fullwidth" style="font-size: 90%; border-top: 1px solid #eee;">
                <tbody>
                    <tr v-for="user in users" :key="user.id" style="width: 100%; border-bottom: 1px solid #eee;">
                        <td style="width: 60%; line-height: 1.25; padding: 10px 0;">
                            <span>{{ user.name }}</span> <br />
                            <span style="font-size: 80%;">{{ user.email }}</span>
                        </td>
                        <td style="width: 35%; line-height: 1.25; text-align: right; vertical-align: middle; padding: 10px 0;">
                            <b-select v-model="user.role" style="font-size: 90%;" @input="updateRole($event, user)">
                                <option value="reader">Consulter la ligne du temps</option>
                                <option value="writer">Modifier la ligne du temps</option>
                                <option value="contributor">Contribuer à la ligne du temps</option>
                            </b-select>
                        </td>
                        <td style="width: 5%; line-height: 1.25; text-align: center; vertical-align: middle; padding: 10px 0;">
                            <a class="button is-white" @click="revoke(user)" style="font-size: 90%;">
                                <i class="fa fa-trash-o fa-lg" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>
                    <tr v-if="timeline.published" style="width: 100%; border-bottom: 1px solid #eee;">
                        <td style="width: 60%; line-height: 1.25; padding: 10px 0;">
                            <span>Quiconque possédant votre lien public</span><br />
                            <span style="font-size: 80%;">{{ timeline.public_link_url }}</span>
                        </td>
                        <td style="width: 35%; line-height: 1.25; text-align: right; vertical-align: middle; padding: 10px 0;">
                            <b-select value="reader" style="font-size: 90%;" disabled>
                                <option value="reader">Consulter la ligne du temps</option>
                                <option value="writer">Modifier la ligne du temps</option>
                                <option value="contributor">Contribuer à la ligne du temps</option>
                            </b-select>
                        </td>
                        <td style="width: 5%; line-height: 1.25; text-align: center; vertical-align: middle; padding: 10px 0;">
                            
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>
                <button @click="inviteForm=true" class="button is-primary">Inviter des personnes</button>
            </p>
</template>
            <template v-if="inviteForm">
			<form method="POST">
                <!-- Email field -->
                <b-field label="Adresse email" :type="form.errors.has('email') ? 'is-danger' : ''" :message="form.errors.first('email')">
                        <b-input type="text" v-model="form.email" autofocus> </b-input>
                </b-field>

                <b-field label="Permissions" :type="form.errors.has('role') ? 'is-danger' : ''" :message="form.errors.first('role')">
                    <b-select v-model="form.role">
                        <option value="reader">Consulter la ligne du temps</option>
                        <option value="writer">Modifier la ligne du temps</option>
                        <option value="contributor">Contribuer à la ligne du temps</option>
                    </b-select>
                </b-field>

                <!-- Message field -->
                <b-field label="Message" :type="form.errors.has('message') ? 'is-danger' : ''" :message="form.errors.first('message')">
                        <b-input type="textarea" v-model="form.message"> </b-input>
                </b-field>
            </form>

                            <div class="field" style="margin-top: 1rem;">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing" style="margin-right: 0.5em;">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Envoyer l'invitation</span>
                    </button>
                    <button class="button" type="button" @click="inviteForm=false">Annuler</button>
                </div>
            </div>
            </template>
		</section>
	</div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: ['timeline'],

    data() {
        return {
            users: [],
            invites: [],
            form: new Form({
                email: '',
                timeline: 0,
                role: '',
                message: ''
            }),
            inviteForm: false,
        }
    },
    
    methods: {

        fetchUsers() {
            this.loading = true;

            axios.get('/api/v1/timelines/'+this.timeline.id+'/users')
                .then(response => {
                    this.loading = false;
                    this.users = _.filter(response.data.users, function(u) { return u.role != 'owner' });
                })
                .catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
        },

        submit() {

            this.form.post('/api/v1/invites', {
                email: this.form.email,
                message: this.form.description,
                role: this.form.role,
                timeline: this.form.timeline
            }).then( response => {

                this.$buefy.toast.open({
                    message: 'Votre invitation a été envoyée',
                    type: 'is-success'
                });

                this.inviteForm = false;

                Bus.$emit('timeline.fetch');

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },

        updateRole(role, user) {
            axios.put('/api/v1/memberships', {
                user_id: user.id,
                timeline_id: this.timeline.id,
                role: role
            }).then(response => {
                this.$buefy.toast.open({
                    message: 'Les autorisations d\'accès de ' + user.name + ' ont été adaptées.',
                    type: 'is-success'
                });
            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },

        revoke(user) {

            axios.delete('/api/v1/memberships', { data: {
                user_id: user.id,
                timeline_id: this.timeline.id
            }}).then(response => {    
                this.$buefy.toast.open({
                    message: user.name + ' ne peut plus accéder à cette ligne du temps.',
                    type: 'is-success'
                });

                this.fetchUsers();

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        }
    },

    created() {

        this.fetchUsers();

        this.form.setInitialValues({
            timeline: this.timeline.id,
            email: '',
            role: '',
            message: '',
        });

        this.form.populate({
            timeline: this.timeline.id
        });
    }
}

</script>

<style>
</style>
